import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/producers'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'producers'

export const metadata = {
  icon: 'industry',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE],
  enableSaveAsNew: true,
  saveAsNewTextKey: 'producers.saveAsSupplier',
  saveAsNewTooltipKey: 'producers.saveAsSupplierTitle',
  saveAsNewDataFlag: { saveAsSupplier: true },
  saveAsNewIcon: 'truck'
}

const ProducersListPage = createListPage({ metadata, api, actionCreators, Content })
const ProducersDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { ProducersListPage, ProducersDetailPage }
